// User-agent fragment present in the OnTheSnow app's embedded
// webview. Used to suppress the promo banner when the page is
// already running inside the app.
export const APP_USER_AGENT = 'OnTheSnow/7.0.0';

// Apple App Store ID for the OnTheSnow app. Used by Safari's native
// smart banner via the `apple-itunes-app` meta tag.
export const APP_STORE_ID = '300412347';
